module.exports = __webpack_public_path__ + "img/up-arrow-white-1M5Zz6k.svg";